<div style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
  ">

    <span style="color: white; float: right; margin: 4% 7%; position: relative;" *ngIf="(version)"> <h6>V{{version}}</h6> </span>
    <p-dialog [(visible)]="displaypopup"
              [draggable]="false"
              [modal]="true"
              positionType="absolute"
              [closable]="false"
              [maximizable]="false"
              [style]="{ width: '90%', 'max-width': '450px' }">
        <p-header>
            <h2 class="mb-0 pl-2"
                style="font-weight: unset !important; font-size: larger !important">
                <i class="pi pi-shield"> &nbsp; </i>Change Password
            </h2>
        </p-header>

        <div class="grid">

           

            <div class="col-12 p-messagesp-messages-summary border-radius-5" style="font-size: 0.9rem; color: #ff0000; text-align: center">
                <span>Your password is weak or has expired and must be changed.</span>
            </div>

            <div class="col-12 col-md-6">
                <form [formGroup]="changePassword" (ngSubmit)="resetPassword()">
                    <div class="p-fluid formgrid grid" style="justify-content: center">
                        <div class="field col-12 md:col-12">
                            <span class="field p-float-label">
                                <input id="float-input1"
                                       type="password"
                                       appFormErrorMessages
                                       pInputText
                                       formControlName="newPassword"
                                       autocomplete="off" />

                                <label for="float-input1">
                                    <span class="required-asteric"> * </span>New Password
                                </label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-12">
                            <span class="field p-float-label">
                                <input id="float-input2"
                                       type="password"
                                       appFormErrorMessages
                                       pInputText
                                       formControlName="confirmPassword"
                                       autocomplete="off" />
                                <label for="float-input1">
                                    <span class="required-asteric"> * </span>Confirm
                                    Password
                                </label>
                            </span>
                        </div>

                        <div class="field col-12 md:col-12 buttonWidth-9 mb-0">
                            <button pButton
                                    type="submit"
                                    icon=""
                                    label="Confirm"
                                    class="p-button-plain"
                                    [disabled]="changePassword.invalid"></button>
                        </div>
                    </div>
                </form>

                <p>&nbsp;</p>

                <div class="col-12 p-messagesp-messages-summary border-radius-5"
                     *ngIf="ShowErrorSummary"
                     style="font-size: 0.9rem; color: #ff0000; text-align: center">
                    <span>{{ errorValidationSummary }}</span>
                </div>
            </div>
        </div>
    </p-dialog>

    <p-dialog header="Confirmation!"
              [(visible)]="display"
              [style]="{ width: '500px' }"
              [maximizable]="false"
              [closable]="false"
              [draggable]="false"
              [resizable]="false">
        <p>
            {{ logoutmsg }}
        </p>
        <ng-template pTemplate="footer">
            <p-button icon="pi pi-check"
                      (click)="logout()"
                      label="Ok"
                      styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog>
</div>
